/* unplugin-vue-components disabled */import script from "./WeiXinGameJudgeModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WeiXinGameJudgeModal.vue?vue&type=script&setup=true&lang=ts"

import "./WeiXinGameJudgeModal.vue?vue&type=style&index=0&id=3bc46a04&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc46a04"]])

export default __exports__